import React from "react";
import dayjs from "dayjs";
import { useProviderDisbursements } from "../../OffCycleDisbursementsReport/useProviderDisbursements";
import { DateRange, DateRangePicker } from "Components/Shared/DateRangePicker/DateRangePicker";

const MAX_DATE = dayjs();
const MIN_DATE = MAX_DATE.subtract(1, "year");


export const DisbursementsDatePicker = () => {
  const { beginDate, endDate, onChangeDateRange } = useProviderDisbursements();

  const selectedRange: DateRange = {
    start: beginDate ? dayjs(beginDate).toDate() : null,
    end: endDate ? dayjs(endDate).toDate() : null,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDatePickerValueChange = (range: DateRange) => {
    onChangeDateRange({
      beginDate: range.start,
      endDate: range.end,
    });
  };

  return (
    <DateRangePicker
      selectedRange={selectedRange}
      onDateRangeChange={handleDatePickerValueChange}
      maxDate={MAX_DATE.toDate()}
      minDate={MIN_DATE.toDate()}
    />
  );
};
